import {
  InvoicePaymentConfig,
  ApartmentListingConfig,
  IndustrialPremisesListingConfig,
  ParkingSpotListingConfig,
  RoundingOccurrenceConfig,
  RoundingSettingConfig,
  ComponentTypeConfig,
  ComponentModelConfig,
  ExternalSupplierConfig,
  VerificationGroupConfig,
  RevenueIncreaseCollectionConfig,
  AddressConfig,
  ApartmentConfig,
  ApartmentContractConfig,
  ApartmentVacancyNotationConfig,
  BlockContractConfig,
  BrfApartmentConfig,
  BrfCompanyConfig,
  BuildingConfig,
  CommonAreaConfig,
  CommunityConfig,
  CompanyConfig,
  ExternalClientConfig,
  GeneralErrandConfig,
  IndustrialPremisesConfig,
  IndustrialPremisesContractConfig,
  IndustrialPremisesVacancyNotationConfig,
  InspectionErrandConfig,
  InvoiceConfig,
  OrganizationUserConfig,
  OtherContractConfig,
  OutdoorAreaConfig,
  OutdoorSectionConfig,
  OutdoorSectionContractConfig,
  OutdoorSectionVacancyNotationConfig,
  ParkingLotConfig,
  ParkingSpotConfig,
  ParkingSpotContractConfig,
  ParkingSpotVacancyNotationConfig,
  PriceGroupConfig,
  RealEstateConfig,
  RegionConfig,
  SegmentConfig,
  SendOutConfig,
  SensorConfig,
  SensorSpecificationConfig,
  SubTenantConfig,
  TenantConfig,
  VacancyInvoiceConfig,
  type FieldValue,
  type ModelName,
} from '@pigello/pigello-matrix';
import queryString from 'query-string';

export const Urls = {
  anonymousErrand: (customerId: string, id: string) =>
    `/errand/anonymous/${customerId}/${id}`,
  privacyPolicy: '/privacy-policy',
  createUser: {
    base: '/create-user/base',
    kind: '/create-user/kind',
    workengagements: '/create-user/workengagements',
    summary: '/create-user/summary',
  },
  marketApartmentBulk: '/market-apartment-bulk',
  apartmentListingBulk: '/apartment-listing-bulk',
  listingPublicationBulk: '/listing-publication-bulk',
  inviteTenants: (realEstateIds: string[]) =>
    `/invite-tenants${
      realEstateIds?.length > 0
        ? `?realEstateIds=${realEstateIds.join(',')}`
        : ''
    }`,
  revenueIncrease: {
    perform: '/revenue-increase/perform',
  },
  errandConfigurations: {
    inspections: {
      handle: {
        baseSettings: (id: string, isCreate?: boolean) =>
          `/errand-configurations/inspections/handle/${id}/base-settings${isCreate ? '?create=true' : ''}`,
        content: (id: string, isCreate?: boolean) =>
          `/errand-configurations/inspections/handle/${id}/content${isCreate ? '?create=true' : ''}`,
        delegation: (id: FieldValue<string>, isCreate?: boolean) =>
          `/errand-configurations/inspections/handle/${id}/delegation${isCreate ? '?create=true' : ''}`,
        summary: (id: FieldValue<string>, isCreate?: boolean) =>
          `/errand-configurations/inspections/handle/${id}/summary${isCreate ? '?create=true' : ''}`,
      },
    },
    generalErrands: {
      handle: {
        baseSettings: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/base-settings${isCreate ? '?create=true' : ''}`,
        fieldSettings: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/field-settings${isCreate ? '?create=true' : ''}`,
        defaultActions: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/default-actions${isCreate ? '?create=true' : ''}`,
        connections: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/connections${isCreate ? '?create=true' : ''}`,
        delegation: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/delegation${isCreate ? '?create=true' : ''}`,
        permissions: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/permissions${isCreate ? '?create=true' : ''}`,
        customFields: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/custom-fields${isCreate ? '?create=true' : ''}`,
        bookings: (id: string, isCreate?: boolean) =>
          `/errand-configurations/general-errands/handle/${id}/bookings${isCreate ? '?create=true' : ''}`,
      },
    },
    rounds: {
      create: () => '/errand-configurations/rounds/create',
      handle: {
        settings: (id: string, isCreate?: boolean) =>
          `/errand-configurations/rounds/handle/${id}/settings${isCreate ? '?create=true' : ''}`,
        content: (id: string, isCreate?: boolean) =>
          `/errand-configurations/rounds/handle/${id}/content${isCreate ? '?create=true' : ''}`,
        delegation: (id: string, isCreate?: boolean) =>
          `/errand-configurations/rounds/handle/${id}/delegation${isCreate ? '?create=true' : ''}`,
      },
    },
  },
  imdimport: {
    file: '/imd-import/file',

    mapsensors: '/imd-import/map-sensors',
  },

  detailedLogs: {
    overview: (modelName: string, id: string) =>
      `/detailed-logs/${modelName}/${id}`,
  },
  brfFlows: {
    transactionDeclaration: {
      generate: (year: string, brfCompanyId: string) =>
        `/brf/transaction-declaration/${brfCompanyId}/${year}/generate`,
      overview: (year: string, brfCompanyId: string) =>
        `/brf/transaction-declaration/${brfCompanyId}/${year}/overview`,
      handleSingle: (brfCompanyId: string, year: string, id: string) =>
        `/brf/transaction-declaration/handle/${brfCompanyId}/${year}/${id}`,
    },
    transaction: {
      create: (brfApartmentId: string) =>
        `/brf/transaction/create/${brfApartmentId}`,
    },
    invoicingContract: {
      create: (brfApartmentId: string) =>
        `/brf/invoicing-contract/create/${brfApartmentId}`,

      handle: (brfApartmentInvoicingConfigurationId: string) =>
        `/brf/invoicing-contract/handle/${brfApartmentInvoicingConfigurationId}`,
    },
    quotaCollection: {
      create: {
        settings: (brfId: string) =>
          `/brf/quotacollection/create/settings?brf=${brfId}`,

        quotas: (brfId: string) =>
          `/brf/quotacollection/create/quotas?brf=${brfId}`,
        summary: (brfId: string) =>
          `/brf/quotacollection/create/summary?brf=${brfId}`,
      },
      edit: {
        quotas: (collectionId: string) =>
          `/brf/quotacollection/edit/quotas?collection=${collectionId}`,
        summary: (collectionId: string) =>
          `/brf/quotacollection/edit/summary?collection=${collectionId}`,
      },
    },
    fee: {
      create: (brfCompanyId: string) => `/brf/fee/handle?brf=${brfCompanyId}`,
      edit: (brfCompanyId: string, feeId: string) =>
        `/brf/fee/handle?brf=${brfCompanyId}&id=${feeId}`,
    },
    debt: {
      create: (brfCompanyId: string) => `/brf/debt/handle?brf=${brfCompanyId}`,
      edit: (brfCompanyId: string, debtId: string) =>
        `/brf/debt/handle?brf=${brfCompanyId}&id=${debtId}`,
    },
    capitalContribution: {
      create: {
        settings: (brfCompanyId: string) =>
          `/brf/capital-contribution/create/settings?brf=${brfCompanyId}`,
        distribution: (brfCompanyId: string) =>
          `/brf/capital-contribution/create/distribution?brf=${brfCompanyId}`,
        summary: (brfCompanyId: string) =>
          `/brf/capital-contribution/create/summary?brf=${brfCompanyId}`,
      },
      edit: (collectionId: string) =>
        `/brf/capital-contribution/edit/${collectionId}`,
    },
  },
  notification: {
    overview: (id: string) => `/notification/${id}`,
    native: {
      overview: (id: string) => `/notification/native/${id}`,
    },
    web: {
      overview: (id: string) => `/notification/web/${id}`,
    },
  },
  documents: {
    overview: '/documents/folders',
    folder: (id: string) => `/documents/folders/${id}`,
    pdf: (id: string, modelName: ModelName) =>
      `/documents/pdf/${modelName}/${id}`,
  },
  dashboard: {
    reports: {
      report: ({
        kind,
        templateId,
        basedOn,
        variant,
      }: {
        kind: string;
        // only one of these three should be passed
        templateId?: string; // id of reporttemplate
        basedOn?: string; // id of reportresult
        variant?: string; // internalid from constants in report folder
      }) =>
        `/dashboard/reports/report/${kind}${templateId ? `?template=${templateId}` : ''}${basedOn ? `?basedon=${basedOn}` : ''}${variant ? `?variant=${variant}` : ''}`,
      available: '/dashboard/reports/available-reports',
      myTemplates: '/dashboard/reports/created-templates',
      sharedTemplates: '/dashboard/reports/shared-templates',
      performed: '/dashboard/reports/performed',
    },
    reportsDw: {
      objects: '/reports-dw/objects',
      rentroll: '/reports-dw/rentroll',
      vacancies: '/reports-dw/vacancies',
      errands: '/reports-dw/errands',
      invoices: '/reports-dw/invoices',
    },
    bookmarks: '/dashboard/bookmarks',
    workflows: '/dashboard/workflows',
    technicalmanagement: {
      status: '/dashboard/technical-management/status',
      errands: '/dashboard/technical-management/errands',
      inspections: '/dashboard/technical-management/inspections',
      components: '/dashboard/technical-management/components',
      rounds: '/dashboard/technical-management/rounds',
      regulatoryInspections:
        '/dashboard/technical-management/regulatory-inspections',
      roundCalendar: '/dashboard/technical-management/round-calendar',
    },
    getStarted: '/dashboard/get-started',
    home: '/dashboard/my-workday',
    inbox: {
      overview: '/dashboard/inbox',
      signings: '/dashboard/inbox/pending-signings',
      approvals: '/dashboard/inbox/pending-approvals',
      performs: '/dashboard/inbox/pending-performs',
      retroactivity: '/dashboard/inbox/retroactivity-proposals',
      distribution: '/dashboard/inbox/distribution-proposals',
      retroactivityModel: (modelName: ModelName) =>
        `/dashboard/inbox/retroactivity-proposals/${modelName}`,
      approvalmodel: (modelName: ModelName) =>
        `/dashboard/inbox/pending-approvals/${modelName}`,
      errands: '/dashboard/inbox/pending-errands',
      inspections: '/dashboard/inbox/pending-inspections',
      rounds: '/dashboard/inbox/pending-rounds',
      chat: (id?: string) =>
        `/dashboard/inbox/chat${id ? `?chatId=${id}` : ''}`,
    },
    companies: '/dashboard/companies',
    brfCompanies: '/dashboard/brf-associations',
    externalclients: '/dashboard/external-clients',
    structural: {
      regions: '/dashboard/structural/regions',
      communities: '/dashboard/structural/communities',
      segments: '/dashboard/structural/segments',
      realestates: '/dashboard/structural/realestates',
      outdoorareas: '/dashboard/structural/outdoorareas',
      buildings: '/dashboard/structural/buildings',
      parkinglots: '/dashboard/structural/parking-lots',
      addresses: '/dashboard/structural/addresses',
    },
    imd: {
      overview: '/dashboard/imd/overview',
      sensorspecifications: '/dashboard/imd/sensor-specifications',
      sensors: '/dashboard/imd/sensors',
      pricegroups: '/dashboard/imd/price-groups',
      importdata: '/dashboard/imd/import-data',
    },
    apartments: '/dashboard/apartments',
    industrialPremises: '/dashboard/industrial-premises',
    outdoorSections: '/dashboard/outdoor-sections',
    parkingSpots: '/dashboard/parking-spots',
    commonAreas: '/dashboard/common-areas',
    brf: {
      brfApartments: '/dashboard/brf-apartments',
    },
    contracts: {
      signingProcesses: (modelName: ModelName) =>
        `/dashboard/digital-signing/processes?modelname=${modelName}&from=contracts`,
      apartment: '/dashboard/contracts/apartment',
      apartmentdrafts: '/dashboard/contracts/apartment/drafts',
      apartmentCancellationprocesses:
        '/dashboard/contracts/apartment/cancellation-processes',
      industrialPremises: '/dashboard/contracts/industrial-premises',
      industrialPremisesdrafts:
        '/dashboard/contracts/industrial-premises/drafts',
      industrialPremisesCancellationprocesses:
        '/dashboard/contracts/industrial-premises/cancellation-processes',
      parkingSpot: '/dashboard/contracts/parking-spot',
      parkingSpotdrafts: '/dashboard/contracts/parking-spot/drafts',
      parkingSpotCancellationprocesses:
        '/dashboard/contracts/parking-spot/cancellation-processes',
      outdoorSection: '/dashboard/contracts/outdoor-section',
      outdoorSectiondrafts: '/dashboard/contracts/outdoor-section/drafts',
      outdoorSectionCancellationprocesses:
        '/dashboard/contracts/outdoor-section/cancellation-processes',
      otherContracts: '/dashboard/contracts/other-contracts',
      otherContractdrafts: '/dashboard/contracts/other-contracts/drafts',
      otherContractCancellationprocesses:
        '/dashboard/contracts/other-contracts/cancellation-processes',
      blockContracts: '/dashboard/contracts/block-contracts',
      blockContractdrafts: '/dashboard/contracts/block-contracts/drafts',
      blockContractCancellationprocesses:
        '/dashboard/contracts/block-contracts/cancellation-processes',
    },
    vacancyContracts: {
      apartment: '/dashboard/vacancy-contracts/apartment',
      industrialPremises: '/dashboard/vacancy-contracts/industrial-premises',
      outdoorSection: '/dashboard/vacancy-contracts/outdoor-section',
      parkingSpot: '/dashboard/vacancy-contracts/parking-spot',
    },
    tenants: '/dashboard/tenants',
    protectedIdentities: '/dashboard/tenants/protected-identities',
    subTenants: '/dashboard/sub-tenants',
    brfMembers: '/dashboard/brf-members',
    invoicing: {
      overview: '/dashboard/invoicing/overview',
      status: '/dashboard/invoicing/status',
      companyStatus: '/dashboard/invoicing/status/companies',
      realestateStatus: '/dashboard/invoicing/status/realestates',
      automaticContractInvoicingControl:
        '/dashboard/invoicing/status/automatic-contract-invoicing-control',
      failedDelivieries: '/dashboard/invoicing/failed-deliveries',
      failedMerges: '/dashboard/invoicing/status/failed-merges',
      invoices: '/dashboard/invoicing/invoices',
      nonRentalInvoices: '/dashboard/invoicing/non-rental-invoices',
      nonAttestedDebthandling: '/dashboard/invoicing/non-attested-debthandling',
      accounting: '/dashboard/invoicing/accounting',
      accounts: '/dashboard/invoicing/accounts',
      payments: '/dashboard/invoicing/payments',
      verificationGroups: '/dashboard/invoicing/verification-groups',
      verifications: '/dashboard/invoicing/verifications',
      indeterminateVerifications:
        '/dashboard/invoicing/verifications/indeterminate',
      bookkeepingExport: '/dashboard/invoicing/bookkeeping-export',
      vacancyInvoices: '/dashboard/invoicing/vacancy-invoices',
      failedAutogiroTransactionAttempts:
        '/dashboard/invoicing/failed-autogiro-transaction-attempts',
      pendingAutogiroTransactionAttempts:
        '/dashboard/invoicing/pending-autogiro-transaction-attempts',
      psFinanceEvents: '/dashboard/invoicing/ps-finance',
    },
    market: {
      applicants: '/dashboard/market/applicants',
      apartmentListings: '/dashboard/market/apartment-listings',
      uppsalaBostadsformedlingLogs:
        '/dashboard/market/apartment-listings/uppsala-bostadsformedling-logs',
      industrialPremisesListings:
        '/dashboard/market/industrial-premises-listings',
      parkingspotListings: '/dashboard/market/parkingspot-listings',
    },
    keyhandling: {
      keys: '/dashboard/key-handling/keys',
      receipts: '/dashboard/key-handling/receipts',
    },
    sendOuts: '/dashboard/send-outs',
    renovations: {
      overview: '/dashboard/renovations/overview',
      structural: '/dashboard/renovations/structural',
      spaces: '/dashboard/renovations/spaces',
    },
    revenue: {
      distribution: {
        default: '/dashboard/revenue/distribution',
        create: '/dashboard/revenue/distribution/create',
        detail: {
          overview: (id: FieldValue<string>) =>
            `/dashboard/revenue/distribution/${id}/overview`,
          values: (id: FieldValue<string>) =>
            `/dashboard/revenue/distribution/${id}/distributed-values`,
          quotas: (id: FieldValue<string>) =>
            `/dashboard/revenue/distribution/${id}/quotas`,
          settings: (id: FieldValue<string>) =>
            `/dashboard/revenue/distribution/${id}/settings`,
          taxationSettings: (id: FieldValue<string>) =>
            `/dashboard/revenue/distribution/${id}/taxation-connection-settings`,
        },
      },
      indexation: {
        default: '/dashboard/revenue/indexation',
        settings: {
          default: '/dashboard/revenue/indexation/settings',
          detail: (id: FieldValue<string>) =>
            `/dashboard/revenue/indexation/settings/${id}`,
        },
        tables: {
          default: '/dashboard/revenue/indexation/tables',
          create: '/dashboard/revenue/indexation/tables/create',
          detail: (id: FieldValue<string>) =>
            `/dashboard/revenue/indexation/tables/${id}`,
        },
      },
      debitRows: {
        apartment: '/dashboard/revenue/debit-rows/apartment',
        industrialPremises: '/dashboard/revenue/debit-rows/industrial-premises',
        parkingSpot: '/dashboard/revenue/debit-rows/parking-spot',
        outdoorSection: '/dashboard/revenue/debit-rows/outdoor-section',
        brf: '/dashboard/revenue/debit-rows/brf',
        brfContract: '/dashboard/revenue/debit-rows/brf-contract',
        apartmentContract: '/dashboard/revenue/debit-rows/apartment-contract',
        industrialPremisesContract:
          '/dashboard/revenue/debit-rows/industrial-premises-contract',
        parkingSpotContract:
          '/dashboard/revenue/debit-rows/parking-spot-contract',
        outdoorSectionContract:
          '/dashboard/revenue/debit-rows/outdoor-section-contract',
        othercontract: '/dashboard/revenue/debit-rows/other-contract',
      },
      taxation: {
        overview: '/dashboard/revenue/taxation/records',

        record: {
          detail: (id: FieldValue<string>) =>
            `/dashboard/revenue/taxation/records/${id}`,
        },
      },
      revenueIncrease: {
        overview: '/dashboard/revenue/revenue-increase',
      },
      retroactivity: {
        overview: '/dashboard/revenue/retroactivity',
        default:
          '/dashboard/revenue/retroactivity/retroactiveapartmentrevenueproposal',
      },
      customerEarnings: {
        settings: {
          default: '/dashboard/revenue/customer-earnings',
          detail: (id: FieldValue<string>) =>
            `/dashboard/revenue/customer-earnings/${id}`,
        },
      },
    },
  },
  detail: {
    componenttype: {
      overview: (id: FieldValue<string>) => `/detail/componenttype/${id}`,
      componentmodels: (id: FieldValue<string>) =>
        `/detail/componenttype/${id}/componentmodels`,
      components: (id: FieldValue<string>) =>
        `/detail/componenttype/${id}/components`,
      documents: (id: FieldValue<string>) =>
        `/detail/componenttype/${id}/documents`,
    },
    componentmodel: {
      overview: (id: FieldValue<string>) => `/detail/componentmodel/${id}`,
      components: (id: FieldValue<string>) =>
        `/detail/componentmodel/${id}/components`,
      documents: (id: FieldValue<string>) =>
        `/detail/componentmodel/${id}/documents`,
    },
    externalsupplier: {
      overview: (id: FieldValue<string>) => `/detail/externalsupplier/${id}`,
      documents: (id: FieldValue<string>) =>
        `/detail/externalsupplier/${id}/documents`,
      componentmodels: (id: FieldValue<string>) =>
        `/detail/externalsupplier/${id}/componentmodels`,
      components: (id: FieldValue<string>) =>
        `/detail/externalsupplier/${id}/components`,
    },
    errands: {
      overview: (id: FieldValue<string>) => `/detail/generalerrand/${id}`,
      chat: (id: string, chatId?: string) =>
        `/detail/generalerrand/${id}/chat${chatId ? `?chatId=${encodeURIComponent(chatId)}` : ''}`,
      costs: (id: FieldValue<string>) => `/detail/generalerrand/${id}/costs`,
      invoices: (id: FieldValue<string>) =>
        `/detail/generalerrand/${id}/invoices`,
      documents: (id: FieldValue<string>) =>
        `/detail/generalerrand/${id}/documents`,
    },
    inspections: {
      overview: (id: FieldValue<string>) => `/detail/inspectionerrand/${id}`,
      content: (id: FieldValue<string>) =>
        `/detail/inspectionerrand/${id}/content`,
      costs: (id: FieldValue<string>) => `/detail/inspectionerrand/${id}/costs`,
      generalerrands: (id: FieldValue<string>) =>
        `/detail/inspectionerrand/${id}/generalerrands`,
      invoices: (id: FieldValue<string>) =>
        `/detail/inspectionerrand/${id}/invoices`,
      documents: (id: FieldValue<string>) =>
        `/detail/inspectionerrand/${id}/documents`,
    },
    rounds: {
      overview: (id: FieldValue<string>) => `/detail/roundingoccurrence/${id}`,
      content: (id: FieldValue<string>) =>
        `/detail/roundingoccurrence/${id}/content`,
      execution: (id: FieldValue<string>) =>
        `/detail/roundingoccurrence/${id}/execution`,
      costs: (id: FieldValue<string>) =>
        `/detail/roundingoccurrence/${id}/costs`,
      invoices: (id: FieldValue<string>) =>
        `/detail/roundingoccurrence/${id}/invoices`,
      generalerrands: (id: FieldValue<string>) =>
        `/detail/roundingoccurrence/${id}/generalerrands`,
      previous: (id: FieldValue<string>) =>
        `/detail/roundingoccurrence/${id}/previous`,
      documents: (id: FieldValue<string>) =>
        `/detail/roundingoccurrence/${id}/documents`,
    },
    roundingsetting: {
      overview: (id: FieldValue<string>) => `/detail/roundingsetting/${id}`,
      rounds: (id: FieldValue<string>) =>
        `/detail/roundingsetting/${id}/rounds`,
      customFields: (id: FieldValue<string>) =>
        `/detail/roundingsetting/${id}/custom-fields`,
    },
    externalClient: {
      overview: (id: FieldValue<string>) => `/detail/externalclient/${id}`,
      resources: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/resources`,
      companies: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/companies`,
      realestates: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/realestates`,
      buildings: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/buildings`,
      outdoorareas: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/outdoorareas`,
      parkinglots: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/parkinglots`,
      commonareas: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/commonareas`,
      apartments: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/apartments`,
      industrialpremises: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/industrialpremises`,
      outdoorsections: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/outdoorsections`,
      parkingspots: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/parkingspots`,
      tenants: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/tenants`,
      errands: (id: FieldValue<string>) =>
        `/detail/externalclient/${id}/errands`,
    },
    address: {
      overview: (id: FieldValue<string>) => `/detail/address/${id}`,
      realestates: (id: FieldValue<string>) =>
        `/detail/address/${id}/realestates`,
      communities: (id: FieldValue<string>) =>
        `/detail/address/${id}/communities`,
      regions: (id: FieldValue<string>) => `/detail/address/${id}/regions`,
      buildings: (id: FieldValue<string>) => `/detail/address/${id}/buildings`,
      outdoorareas: (id: FieldValue<string>) =>
        `/detail/address/${id}/outdoorareas`,
      parkinglots: (id: FieldValue<string>) =>
        `/detail/address/${id}/parkinglots`,
      apartments: (id: FieldValue<string>) =>
        `/detail/address/${id}/apartments`,
      brfapartments: (id: FieldValue<string>) =>
        `/detail/address/${id}/brfapartments`,
      industrialpremises: (id: FieldValue<string>) =>
        `/detail/address/${id}/industrialpremises`,
      commonareas: (id: FieldValue<string>) =>
        `/detail/address/${id}/commonareas`,
      parkingspots: (id: FieldValue<string>) =>
        `/detail/address/${id}/parkingspots`,
      outdoorsections: (id: FieldValue<string>) =>
        `/detail/address/${id}/outdoorsections`,
    },
    customerColumns: (modelName: ModelName, id: FieldValue<string>) =>
      `/detail/${modelName}/${id}/customercolumns`,
    documents: (modelName: ModelName, id: FieldValue<string>) =>
      `/detail/${modelName}/${id}/documents`,
    renovations: (modelName: ModelName, id: FieldValue<string>) =>
      `/detail/${modelName}/${id}/renovations`,
    imd: (modelName: ModelName, id: FieldValue<string>) =>
      `/detail/${modelName}/${id}/imd`,
    chat: (modelName: ModelName, id: FieldValue<string>) =>
      `/detail/${modelName}/${id}/chat`,
    contract: {
      overview: (modelName: ModelName, id: FieldValue<string>) =>
        `/detail/${modelName}/${id}`,
      revenue: {
        overview: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/revenue-overview`,
        overviewdev: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/revenue-overview-dev`,
        indexation: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/revenue-indexation`,
        retroactivity: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/revenue-retroactivity`,
        increase: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/revenue-increase`,
        customerEarnings: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/customer-earnings`,
      },
      subcontracts: (modelName: ModelName, id: FieldValue<string>) =>
        `/detail/${modelName}/${id}/subcontracts`,
      othercontracts: (modelName: ModelName, id: FieldValue<string>) =>
        `/detail/${modelName}/${id}/othercontracts`,
      invoicing: {
        invoices: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/invoices`,
        payments: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/payments`,
        settings: (modelName: ModelName, id: FieldValue<string>) =>
          `/detail/${modelName}/${id}/invoicing-settings`,
      },
      contractDocuments: (modelName: ModelName, id: FieldValue<string>) =>
        `/detail/${modelName}/${id}/contract-documents`,
      errands: (modelName: ModelName, id: FieldValue<string>) =>
        `/detail/${modelName}/${id}/errands`,
    },
    vacancyContract: {
      overview: (modelName: ModelName, id: string) =>
        `/detail/${modelName}/${id}`,
      vacancyinvoices: (modelName: ModelName, id: string) =>
        `/detail/${modelName}/${id}/vacancy-invoices`,
      lossnotations: (modelName: ModelName, id: string) =>
        `/detail/${modelName}/${id}/loss-notations`,
    },
    sensor: {
      overview: (id: FieldValue<string>) => `/detail/sensor/${id}`,
    },
    pricegroup: {
      overview: (id: FieldValue<string>) => `/detail/pricegroup/${id}`,
    },
    sensorspecification: {
      overview: (id: FieldValue<string>) => `/detail/sensorspecification/${id}`,
      sensors: (id: FieldValue<string>) =>
        `/detail/sensorspecification/${id}/sensors`,
      pricegroup: (id: FieldValue<string>) =>
        `/detail/sensorspecification/${id}/pricegroup`,
    },
    apartment: {
      overview: (id: FieldValue<string>) => `/detail/apartment/${id}`,
      revenue: {
        distribution: (id: FieldValue<string>) =>
          `/detail/apartment/${id}/revenue-distribution`,
        overview: (id: FieldValue<string>) =>
          `/detail/apartment/${id}/revenue-overview`,
        increase: (id: FieldValue<string>) =>
          `/detail/apartment/${id}/revenue-increase`,
      },
      renting: (id: FieldValue<string>) => `/detail/apartment/${id}/renting`,
      contracts: (id: FieldValue<string>) =>
        `/detail/apartment/${id}/contracts`,
      othercontracts: (id: FieldValue<string>) =>
        `/detail/apartment/${id}/othercontracts`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/apartment/${id}/errand-components`,
      errands: (id: FieldValue<string>) => `/detail/apartment/${id}/errands`,
      inspections: (id: string) => `/detail/apartment/${id}/inspections`,
      listings: (id: FieldValue<string>) => `/detail/apartment/${id}/listings`,
      marketPostings: (id: string) => `/detail/apartment/${id}/market-postings`,
      vacancyContracts: (id: FieldValue<string>) =>
        `/detail/apartment/${id}/vacancy-contracts`,
    },
    apartmentListing: {
      overview: (id: FieldValue<string>) => `/detail/apartmentlisting/${id}`,
    },
    industrialPremisesListing: {
      overview: (id: FieldValue<string>) =>
        `/detail/industrialpremiseslisting/${id}`,
    },
    parkingSpotListing: {
      overview: (id: FieldValue<string>) => `/detail/parkingspotlisting/${id}`,
    },
    brfApartment: {
      overview: (id: FieldValue<string>) => `/detail/brfapartment/${id}`,
      transactions: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/transactions`,
      owners: (id: FieldValue<string>) => `/detail/brfapartment/${id}/owners`,
      invoicingSettings: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/invoicing-settings`,
      invoices: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/invoices`,
      debitGenerations: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/debit-generations`,
      subcontracts: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/subcontracts`,
      revenue: {
        overview: (id: FieldValue<string>) =>
          `/detail/brfapartment/${id}/revenue-overview`,
        fees: (id: FieldValue<string>) =>
          `/detail/brfapartment/${id}/revenue-fees`,
        distribution: (id: FieldValue<string>) =>
          `/detail/brfapartment/${id}/revenue-distribution`,
      },
      economy: {
        quotas: (id: FieldValue<string>) => `/detail/brfapartment/${id}/quotas`,
        pledges: (id: FieldValue<string>) =>
          `/detail/brfapartment/${id}/pledges`,
        reparationFund: (id: FieldValue<string>) =>
          `/detail/brfapartment/${id}/reparation-fund`,
        capitalContributions: (id: FieldValue<string>) =>
          `/detail/brfapartment/${id}/capital-contributions`,
      },
      realtorImage: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/realtor-image`,
      othercontracts: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/othercontracts`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/brfapartment/${id}/errand-components`,
      errands: (id: FieldValue<string>) => `/detail/brfapartment/${id}/errands`,
      inspections: (id: string) => `/detail/brfapartment/${id}/inspections`,
    },
    company: {
      overview: (id: FieldValue<string>) => `/detail/company/${id}`,
      realestates: (id: FieldValue<string>) =>
        `/detail/company/${id}/realestates`,
      rentnotifying: {
        settings: (id: FieldValue<string>) =>
          `/detail/company/${id}/rentnotifying-settings`,

        paymentmethods: (id: FieldValue<string>) =>
          `/detail/company/${id}/rentnotifying-paymentmethods`,
        contractinvoicing: (id: FieldValue<string>) =>
          `/detail/company/${id}/rentnotifying-contractinvoicing`,
        paymentterms: (id: FieldValue<string>) =>
          `/detail/company/${id}/rentnotifying-paymentterms`,
      },
      errands: (id: FieldValue<string>) => `/detail/company/${id}/errands`,
    },
    brfCompany: {
      overview: (id: FieldValue<string>) => `/detail/brfcompany/${id}`,
      members: (id: FieldValue<string>) => `/detail/brfcompany/${id}/members`,
      brfApartments: (id: FieldValue<string>) =>
        `/detail/brfcompany/${id}/brfapartments`,
      quotas: (id: FieldValue<string>) => `/detail/brfcompany/${id}/quotas`,
      quotaOverview: (id: FieldValue<string>) =>
        `/detail/brfcompany/${id}/quota-overview`,
      realtorImages: (id: FieldValue<string>) =>
        `/detail/brfcompany/${id}/realtor-images`,

      realestates: (id: FieldValue<string>) =>
        `/detail/brfcompany/${id}/realestates`,
      ku55: (id: FieldValue<string>) => `/detail/brfcompany/${id}/ku55`,
      errands: (id: FieldValue<string>) => `/detail/brfcompany/${id}/errands`,
      economy: {
        fees: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/economy/fees`,
        debt: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/economy/debt`,
        capitalContributions: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/economy/capital-contributions`,
        pledges: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/economy/pledges`,
        objectImage: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/economy/object-images`,
        transactions: (id: string) =>
          `/detail/brfcompany/${id}/economy/transactions`,
      },
      documents: {
        documents: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/documents`,
        financialPlan: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/documents/financial-plan`,
        financialReports: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/documents/financial-reports`,
        statutes: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/documents/statutes`,
      },
      settings: {
        transactionsFees: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/settings/transaction-fees`,
        pledges: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/settings/pledges`,
        reparationFund: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/settings/reparation-fund`,
      },
      rentnotifying: {
        settings: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/rentnotifying-settings`,

        paymentmethods: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/rentnotifying-paymentmethods`,
        contractinvoicing: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/rentnotifying-contractinvoicing`,
        paymentterms: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/rentnotifying-paymentterms`,
      },
      rentableObjects: {
        apartments: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/rentable-apartments`,
        industrialPremises: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/industrial-premises`,
        outdoorSections: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/outdoor-sections`,
        parkingSpots: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/parking-spots`,
      },
      contracts: {
        apartments: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/apartment-contracts`,
        industrialPremises: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/industrial-premises-contracts`,
        outdoorSections: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/outdoor-section-contracts`,
        parkingSpots: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/parking-spot-contracts`,
        other: (id: FieldValue<string>) =>
          `/detail/brfcompany/${id}/other-contracts`,
      },
    },
    building: {
      overview: (id: FieldValue<string>) => `/detail/building/${id}`,
      workengagements: (id: string) => `/detail/building/${id}/workengagements`,
      suppliers: (id: string) => `/detail/building/${id}/suppliers`,
      commonareas: (id: FieldValue<string>) =>
        `/detail/building/${id}/commonareas`,
      apartments: (id: FieldValue<string>) =>
        `/detail/building/${id}/apartments`,
      brfApartments: (id: FieldValue<string>) =>
        `/detail/building/${id}/brfapartments`,
      industrialpremises: (id: FieldValue<string>) =>
        `/detail/building/${id}/industrialpremises`,
      parkingspots: (id: FieldValue<string>) =>
        `/detail/building/${id}/parkingspots`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/building/${id}/errand-components`,
      errands: (id: FieldValue<string>) => `/detail/building/${id}/errands`,
      tenantInformation: {
        default: (id: FieldValue<string>) =>
          `/detail/building/${id}/tenant-information`,
        detail: (
          id: FieldValue<string>,
          tenantInformationCollectionId: FieldValue<string>
        ) =>
          `/detail/building/${id}/tenant-information/${tenantInformationCollectionId}`,
      },
    },
    commonarea: {
      overview: (id: FieldValue<string>) => `/detail/commonarea/${id}`,
      othercontracts: (id: FieldValue<string>) =>
        `/detail/commonarea/${id}/othercontracts`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/commonarea/${id}/errand-components`,
      errands: (id: FieldValue<string>) => `/detail/commonarea/${id}/errands`,
    },
    community: {
      overview: (id: FieldValue<string>) => `/detail/community/${id}`,
      realestates: (id: FieldValue<string>) =>
        `/detail/community/${id}/realestates`,
      errands: (id: FieldValue<string>) => `/detail/community/${id}/errands`,
      tenantInformation: {
        default: (id: FieldValue<string>) =>
          `/detail/community/${id}/tenant-information`,
        detail: (
          id: FieldValue<string>,
          tenantInformationCollectionId: FieldValue<string>
        ) =>
          `/detail/community/${id}/tenant-information/${tenantInformationCollectionId}`,
      },
    },
    industrialpremises: {
      overview: (id: FieldValue<string>) => `/detail/industrialpremises/${id}`,
      revenue: {
        distribution: (id: FieldValue<string>) =>
          `/detail/industrialpremises/${id}/revenue-distribution`,
        overview: (id: FieldValue<string>) =>
          `/detail/industrialpremises/${id}/revenue-overview`,
        increase: (id: FieldValue<string>) =>
          `/detail/industrialpremises/${id}/revenue-increase`,
      },
      contracts: (id: FieldValue<string>) =>
        `/detail/industrialpremises/${id}/contracts`,
      othercontracts: (id: FieldValue<string>) =>
        `/detail/industrialpremises/${id}/othercontracts`,
      renting: (id: FieldValue<string>) =>
        `/detail/industrialpremises/${id}/renting`,

      errandComponents: (id: FieldValue<string>) =>
        `/detail/industrialpremises/${id}/errand-components`,
      errands: (id: FieldValue<string>) =>
        `/detail/industrialpremises/${id}/errands`,
      inspections: (id: string) =>
        `/detail/industrialpremises/${id}/inspections`,
      vacancyContracts: (id: FieldValue<string>) =>
        `/detail/industrialpremises/${id}/vacancy-contracts`,
      listingDetails: (id: string) =>
        `/detail/industrialpremises/${id}/listing-details`,
      marketPostings: (id: string) =>
        `/detail/industrialpremises/${id}/market-postings`,
    },
    outdoorarea: {
      overview: (id: FieldValue<string>) => `/detail/outdoorarea/${id}`,
      workengagements: (id: string) =>
        `/detail/outdoorarea/${id}/workengagements`,
      suppliers: (id: string) => `/detail/outdoorarea/${id}/suppliers`,
      outdoorsections: (id: FieldValue<string>) =>
        `/detail/outdoorarea/${id}/outdoorsections`,
      commonareas: (id: FieldValue<string>) =>
        `/detail/outdoorarea/${id}/commonareas`,
      parkingspots: (id: FieldValue<string>) =>
        `/detail/outdoorarea/${id}/parkingspots`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/outdoorarea/${id}/errand-components`,
      errands: (id: FieldValue<string>) => `/detail/outdoorarea/${id}/errands`,
      inspections: (id: string) => `/detail/outdoorarea/${id}/inspections`,
      tenantInformation: {
        default: (id: FieldValue<string>) =>
          `/detail/outdoorarea/${id}/tenant-information`,
        detail: (
          id: FieldValue<string>,
          tenantInformationCollectionId: FieldValue<string>
        ) =>
          `/detail/outdoorarea/${id}/tenant-information/${tenantInformationCollectionId}`,
      },
    },
    outdoorsection: {
      overview: (id: FieldValue<string>) => `/detail/outdoorsection/${id}`,
      revenue: {
        distribution: (id: FieldValue<string>) =>
          `/detail/outdoorsection/${id}/revenue-distribution`,
        overview: (id: FieldValue<string>) =>
          `/detail/outdoorsection/${id}/revenue-overview`,
        increase: (id: FieldValue<string>) =>
          `/detail/outdoorsection/${id}/revenue-increase`,
      },
      contracts: (id: FieldValue<string>) =>
        `/detail/outdoorsection/${id}/contracts`,
      othercontracts: (id: FieldValue<string>) =>
        `/detail/outdoorsection/${id}/othercontracts`,
      renting: (id: FieldValue<string>) =>
        `/detail/outdoorsection/${id}/renting`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/outdoorsection/${id}/errand-components`,
      errands: (id: FieldValue<string>) =>
        `/detail/outdoorsection/${id}/errands`,
      inspections: (id: string) => `/detail/outdoorsection/${id}/inspections`,
      vacancyContracts: (id: FieldValue<string>) =>
        `/detail/outdoorsection/${id}/vacancy-contracts`,
    },
    organizationuser: {
      overview: (id: FieldValue<string>) => `/detail/organizationuser/${id}`,
      workEngagements: (id: FieldValue<string>) =>
        `/detail/organizationuser/${id}/workengagements`,
      segments: (id: string) => `/detail/organizationuser/${id}/segments`,
      externalClients: (id: string) =>
        `/detail/organizationuser/${id}/externalclients`,
      notificationsettings: (id: string) =>
        `/detail/organizationuser/${id}/notificationsettings`,
      notifications: (id: string) =>
        `/detail/organizationuser/${id}/notifications`,
      automaticDelegations: (id: string) =>
        `/detail/organizationuser/${id}/automatic-delegations`,
      activity: (id: string) => `/detail/organizationuser/${id}/activity`,
    },
    parkinglot: {
      overview: (id: FieldValue<string>) => `/detail/parkinglot/${id}`,
      workengagements: (id: string) =>
        `/detail/parkinglot/${id}/workengagements`,
      suppliers: (id: string) => `/detail/parkinglot/${id}/suppliers`,
      parkingspots: (id: FieldValue<string>) =>
        `/detail/parkinglot/${id}/parkingspots`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/parkinglot/${id}/errand-components`,
      errands: (id: FieldValue<string>) => `/detail/parkinglot/${id}/errands`,
      tenantInformation: {
        default: (id: FieldValue<string>) =>
          `/detail/parkinglot/${id}/tenant-information`,
        detail: (
          id: FieldValue<string>,
          tenantInformationCollectionId: FieldValue<string>
        ) =>
          `/detail/parkinglot/${id}/tenant-information/${tenantInformationCollectionId}`,
      },
    },
    parkingspot: {
      overview: (id: FieldValue<string>) => `/detail/parkingspot/${id}`,
      errands: (id: FieldValue<string>) => `/detail/parkingspot/${id}/errands`,
      inspections: (id: string) => `/detail/parkingspot/${id}/inspections`,
      revenue: {
        distribution: (id: FieldValue<string>) =>
          `/detail/parkingspot/${id}/revenue-distribution`,
        overview: (id: FieldValue<string>) =>
          `/detail/parkingspot/${id}/revenue-overview`,
        increase: (id: FieldValue<string>) =>
          `/detail/parkingspot/${id}/revenue-increase`,
      },
      renting: (id: FieldValue<string>) => `/detail/parkingspot/${id}/renting`,
      contracts: (id: FieldValue<string>) =>
        `/detail/parkingspot/${id}/contracts`,
      othercontracts: (id: FieldValue<string>) =>
        `/detail/parkingspot/${id}/othercontracts`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/parkingspot/${id}/errand-components`,
      vacancyContracts: (id: FieldValue<string>) =>
        `/detail/parkingspot/${id}/vacancy-contracts`,
      listingDetails: (id: string) =>
        `/detail/parkingspot/${id}/listing-details`,
      marketPostings: (id: string) =>
        `/detail/parkingspot/${id}/market-postings`,
    },
    region: {
      overview: (id: FieldValue<string>) => `/detail/region/${id}`,
      communities: (id: FieldValue<string>) =>
        `/detail/region/${id}/communities`,
      errands: (id: FieldValue<string>) => `/detail/region/${id}/errands`,
    },
    segment: {
      overview: (id: FieldValue<string>) => `/detail/segment/${id}`,
      realestates: (id: FieldValue<string>) =>
        `/detail/segment/${id}/realestates`,
      errands: (id: FieldValue<string>) => `/detail/segment/${id}/errands`,
    },
    realestate: {
      overview: (id: FieldValue<string>) => `/detail/realestate/${id}`,
      apartments: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/apartments`,
      brfApartments: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/brfapartments`,
      buildings: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/buildings`,
      commonareas: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/commonareas`,
      industrialpremises: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/industrialpremises`,
      parkingspots: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/parkingspots`,
      parkinglots: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/parkinglots`,
      outdoorareas: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/outdoorareas`,
      taxation: (id: FieldValue<string>) => `/detail/realestate/${id}/taxation`,
      workengagements: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/workengagements`,
      suppliers: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/suppliers`,
      segmentusers: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/segmentusers`,
      errandComponents: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/errand-components`,
      errands: (id: FieldValue<string>) => `/detail/realestate/${id}/errands`,
      inspections: (id: string) => `/detail/realestate/${id}/inspections`,
      notesFaults: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/notes-faults`,
      customFields: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/custom-fields`,
      rounds: (id: FieldValue<string>) => `/detail/realestate/${id}/rounds`,
      regulatoryRounds: (id: FieldValue<string>) =>
        `/detail/realestate/${id}/regulatory-rounds`,
      tenantInformation: {
        default: (id: FieldValue<string>) =>
          `/detail/realestate/${id}/tenant-information`,
        detail: (
          id: FieldValue<string>,
          tenantInformationCollectionId: FieldValue<string>
        ) =>
          `/detail/realestate/${id}/tenant-information/${tenantInformationCollectionId}`,
      },
    },
    revenueIncrease: {
      overview: (id: FieldValue<string>) =>
        `/detail/revenueincreasecollection/${id}`,
      rows: {
        apartment: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/apartment-rows`,
        apartmentContract: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/apartment-contract-rows`,
        industrialPremises: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/industrial-premises-rows`,
        industrialPremisesContract: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/industrial-premises-contract-rows`,
        outdoorSection: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/outdoor-section-rows`,
        outdoorSectionContract: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/outdoor-section-contract-rows`,
        parkingSpot: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/parking-spot-rows`,
        parkingSpotContract: (id: FieldValue<string>) =>
          `/detail/revenueincreasecollection/${id}/parking-spot-contract-rows`,
      },
    },
    tenant: {
      overview: (id: FieldValue<string>) => `/detail/tenant/${id}`,
      invoices: (id: FieldValue<string>) => `/detail/tenant/${id}/invoices`,
      payments: (id: FieldValue<string>) => `/detail/tenant/${id}/payments`,
      customerbalance: (id: FieldValue<string>) =>
        `/detail/tenant/${id}/customer-balance`,
      contracts: (id: FieldValue<string>) => `/detail/tenant/${id}/contracts`,
      othercontracts: (id: FieldValue<string>) =>
        `/detail/tenant/${id}/othercontracts`,
      objects: (id: FieldValue<string>) => `/detail/tenant/${id}/objects`,
      brfApartments: (id: FieldValue<string>) =>
        `/detail/tenant/${id}/brfapartments`,
      customerEarningsReport: (id: FieldValue<string>) =>
        `/detail/tenant/${id}/customer-earnings-report`,
      errands: (id: FieldValue<string>) => `/detail/tenant/${id}/errands`,
      applicationInfo: (id: FieldValue<string>) =>
        `/detail/tenant/${id}/application-info`,
      inspections: (id: string) => `/detail/tenant/${id}/inspections`,
      notifications: (id: FieldValue<string>) =>
        `/detail/tenant/${id}/notifications`,
    },
    subTenant: {
      overview: (id: FieldValue<string>) => `/detail/subtenant/${id}`,
      invoices: (id: FieldValue<string>) => `/detail/subtenant/${id}/invoices`,
      payments: (id: FieldValue<string>) => `/detail/subtenant/${id}/payments`,
      customerbalance: (id: FieldValue<string>) =>
        `/detail/subtenant/${id}/customer-balance`,
      errands: (id: FieldValue<string>) => `/detail/subtenant/${id}/errands`,
      notifications: (id: FieldValue<string>) =>
        `/detail/subtenant/${id}/notifications`,
    },
    invoice: {
      overview: (id: FieldValue<string>) => `/detail/invoice/${id}`,
      reminders: (id: FieldValue<string>) => `/detail/invoice/${id}/reminders`,
      pdfVersions: (id: FieldValue<string>) =>
        `/detail/invoice/${id}/pdf-versions`,
      bookkeeping: (id: FieldValue<string>) =>
        `/detail/invoice/${id}/bookkeeping`,
      distribution: (id: FieldValue<string>) =>
        `/detail/invoice/${id}/distribution`,
      events: (id: FieldValue<string>) => `/detail/invoice/${id}/events`,
    },
    invoicepayment: {
      overview: (id: FieldValue<string>) => `/detail/invoicepayment/${id}`,
    },
    vacancyInvoice: {
      overview: (id: FieldValue<string>) => `/detail/vacancyinvoice/${id}`,
    },
    verificationgroup: {
      overview: (id: FieldValue<string>) => `/detail/verificationgroup/${id}`,
    },
    sendOut: {
      overview: (id: FieldValue<string>) => `/detail/sendout/${id}`,
      distributions: (id: FieldValue<string>) =>
        `/detail/sendout/${id}/distributions`,
    },
    sendOutTemplate: {
      overview: (id: FieldValue<string>) => `/detail/sendout/${id}`,
    },
  },
  invoicing: {
    handle: (id: FieldValue<string>) => `/invoicing/handle/${id}`,
    mergepreview: `/invoicing/merge`,
    generate: `/invoicing/generate`,
    massattest: `/invoicing/attest`,
    massattestAll: `/invoicing/attest-all`,
    massattestvacancy: `/invoicing/attest-vacancy`,
    masspause: '/invoicing/pause',
    massresume: '/invoicing/resume',
    masscredit: '/invoicing/credit',
    masspayment: '/invoicing/pay-internal',
    moveDates: `/invoicing/move-dates`,
  },
  integrationFlow: {
    fortnox: {
      activation: '/integration-flow/fortnox/activation',
      finalize: '/integration-flow/fortnox/finalize',
    },
    vismaEEconomy: {
      activation: '/integration-flow/visma-e-ekonomi/activation',
      finalize: '/integration-flow/visma-e-ekonomi/finalize',
    },
    homeQ: '/integration-flow/homeq/',
    outlook: {
      bookings: {
        activation: '/integration-flow/outlook/bookings/activation',
        finalize: '/integration-flow/outlook/bookings/finalize',
      },
    },
    fastdoc: {
      selectTemplate: (
        integrationUserAgentId: string,
        modelName: ModelName,
        contractId: string,
        category: 0 | 1 | 2 | undefined,
        cancellationPositionId?: string
      ) =>
        `/integration-flow/fastdoc/${integrationUserAgentId}/${modelName}/${contractId}/select-template?category=${category}${cancellationPositionId ? `&cancellationPositionId=${cancellationPositionId}` : ''}`,
      selectAttachments: (
        integrationUserAgentId: string,
        modelName: ModelName,
        contractId: string,
        category: 0 | 1 | 2 | undefined,
        cancellationPositionId?: string
      ) =>
        `/integration-flow/fastdoc/${integrationUserAgentId}/${modelName}/${contractId}/select-attachments?category=${category}${cancellationPositionId ? `&cancellationPositionId=${cancellationPositionId}` : ''}`,
      settings: (
        integrationUserAgentId: string,
        modelName: ModelName,
        contractId: string,
        category: 0 | 1 | 2 | undefined,
        cancellationPositionId?: string
      ) =>
        `/integration-flow/fastdoc/${integrationUserAgentId}/${modelName}/${contractId}/settings?category=${category}${cancellationPositionId ? `&cancellationPositionId=${cancellationPositionId}` : ''}`,
      documents: (
        integrationUserAgentId: string,
        modelName: ModelName,
        contractId: string,
        category: 0 | 1 | 2 | undefined,
        cancellationPositionId?: string
      ) =>
        `/integration-flow/fastdoc/${integrationUserAgentId}/${modelName}/${contractId}/documents?category=${category}${cancellationPositionId ? `&cancellationPositionId=${cancellationPositionId}` : ''}`,
      parties: (
        integrationUserAgentId: string,
        modelName: ModelName,
        contractId: string,
        category: 0 | 1 | 2 | undefined,
        cancellationPositionId?: string
      ) =>
        `/integration-flow/fastdoc/${integrationUserAgentId}/${modelName}/${contractId}/parties?category=${category}${cancellationPositionId ? `&cancellationPositionId=${cancellationPositionId}` : ''}`,
    },
  },
  signing: {
    handle: (id: string) => `/signing/handle/${id}`,
    sign: (id: string) => `/signing/sign/${id}`,
  },
  settings: {
    activity: '/settings/activity',
    profile: {
      settings: '/settings/profile/settings',
      customization: '/settings/profile/customization',
      notificationsettings: '/settings/profile/notification-settings',
      sessions: '/settings/profile/sessions',
    },
    admin: {
      customers: '/settings/admin/customers',
      customer: (id: string) => `/settings/admin/customers/${id}`,
    },
    organization: {
      bankid: {
        default: '/settings/organization/bankid',
      },
      users: {
        default: '/settings/organization/users',
      },
      supportAccounts: {
        default: '/settings/organization/support-accounts',
      },

      segments: {
        default: '/settings/organization/segments',
        create: '/settings/organization/segments/create',
        segment: (id: FieldValue<string>) =>
          `/settings/organization/segments/${id}` as const,
        edit: (id: FieldValue<string>) =>
          `/settings/organization/segments/${id}/edit` as const,
      },
      organizationconfig: {
        default: '/settings/organization/organizations',
        create: '/settings/organization/organizations/create',
        edit: (id: FieldValue<string>) =>
          `/settings/organization/organizations/${id}` as const,
      },
      roles: {
        default: '/settings/organization/roles',
        create: '/settings/organization/roles/create',
        createGroupKey: (groupKey: string) =>
          `/settings/organization/roles/create/${groupKey}` as const,
        role: (id: FieldValue<string>) =>
          `/settings/organization/roles/${id}` as const,
        roleGroupKey: (id: FieldValue<string>, groupKey: string) =>
          `/settings/organization/roles/${id}/${groupKey}` as const,
        edit: (id: FieldValue<string>) =>
          `/settings/organization/roles/${id}/edit` as const,
      },
      workengagements: {
        default: '/settings/organization/work-engagements',
        users: (id: FieldValue<string>) =>
          `/settings/organization/work-engagements/${id}/users`,
        suppliers: (id: FieldValue<string>) =>
          `/settings/organization/work-engagements/${id}/suppliers`,
        notifications: (id: string) =>
          `/settings/organization/work-engagements/${id}/notifications`,
        dashboard: (id: string) =>
          `/settings/organization/work-engagements/${id}/dashboard`,
        workflows: (id: string) =>
          `/settings/organization/work-engagements/${id}/workflows`,
      },
      monitoringconfigurations: {
        default: '/settings/organization/monitoring-configurations',
        monitoringconfiguration: (id: FieldValue<string>) =>
          `/settings/organization/monitoring-configurations/${id}` as const,
        edit: (id: FieldValue<string>) =>
          `/settings/organization/monitoring-configurations/${id}/edit` as const,
        approvers: (id: FieldValue<string>) =>
          `/settings/organization/monitoring-configurations/${id}/approvers` as const,
      },
      rentableterms: {
        parkingspot: (id: FieldValue<string>) =>
          `/settings/organization/rentable-terms/parking-spot/${id}` as const,
      },
      branding: {
        default: '/settings/organization/branding',
      },
      systemManagers: {
        default: '/settings/organization/system-managers',
      },
      ssoConfiguration: {
        default: '/settings/organization/sso-configuration',
      },
      validationconfig: {
        default:
          '/settings/organization/globalconfigurations/validation-config',
      },
      securityconfig: {
        default: '/settings/organization/globalconfigurations/security-config',
      },
      gdprconfig: {
        default: '/settings/organization/gdpr-configurations',
      },
      retroactivityconfig: {
        default:
          '/settings/organization/globalconfigurations/retroactivity-config',
        create: '/settings/organization/retroactivity-config/create',
        edit: '/settings/organization/retroactivity-config/edit',
      },
      tags: {
        default: '/settings/organization/tags',
      },
      customercolumntype: {
        default: '/settings/organization/customercolumntypes',
        create: '/settings/organization/customercolumntypes/create',
      },
      integrations: '/settings/organization/integrations',
      integrationsExplore: '/settings/organization/integrations/explore',
      integration: (
        applicationId: string,
        serviceId: string,
        objectId?: string
      ) =>
        `/settings/organization/integrations/${applicationId}/${serviceId}${objectId ? `?object_id=${objectId}` : ''}`,
    },

    modules: {
      base: {
        swedishPriceBase: '/settings/modules/base/swedish-price-base',
        swedishReferenceRate: '/settings/modules/base/reference-rate',
        contractcancellations: {
          settings: '/settings/modules/base/contractcancellations/settings',
          setting: (id: FieldValue<string>) =>
            `/settings/modules/base/contractcancellations/settings/${id}`,
          reasons: '/settings/modules/base/contractcancellations/reasons',
        },
        signingTemplates: '/settings/modules/base/signing-templates',
      },
      presets: {
        subtenant: {
          default: '/settings/modules/presets/sub-tenant',
        },
      },
      errands: {
        componentsettings: {
          componenttypes:
            '/settings/modules/errands/component-settings/component-types',
          roomcategories:
            '/settings/modules/errands/component-settings/room-categories',
          componentmodels:
            '/settings/modules/errands/component-settings/component-models',
          componentconditionvalues:
            '/settings/modules/errands/component-settings/component-condition-values',
        },
        general: {
          types: '/settings/modules/errands/general/types',
        },
        external: {
          suppliers: '/settings/modules/errands/external/suppliers',
        },
        default: {
          descriptions: '/settings/modules/errands/default/descriptions',
          actions: '/settings/modules/errands/default/actions',
        },
        inspection: {
          types: '/settings/modules/errands/inspection/types',
          protocolsettings:
            '/settings/modules/errands/inspection/protocolsettings',
          statuses: '/settings/modules/errands/inspection/statuses',
          customfields: '/settings/modules/errands/inspection/custom-fields',
        },
        rounds: {
          categories: '/settings/modules/errands/rounds/categories',
          checklistrowcategories:
            '/settings/modules/errands/rounds/checklist-row-categories',
          templates: '/settings/modules/errands/rounds/templates',
          customfields: '/settings/modules/errands/rounds/custom-fields',
          settings: '/settings/modules/errands/rounds/settings',
        },
        maintenance: '/settings/modules/errands/maintenance',
        regulatoryrounds: {
          templates: '/settings/modules/errands/regulatory-rounds/templates',
          categories: '/settings/modules/errands/regulatory-rounds/categories',
          checklistrowcategories:
            '/settings/modules/errands/regulatory-rounds/checklist-row-categories',
          customfields:
            '/settings/modules/errands/regulatory-rounds/custom-fields',
        },
      },
      invoicing: {
        accounting: {
          general: '/settings/modules/invoicing/accounting/general',
          accounts: '/settings/modules/invoicing/accounting/accounts',
          method: '/settings/modules/invoicing/accounting/method',
          verifications: '/settings/modules/invoicing/accounting/verifications',
          paymentmethods:
            '/settings/modules/invoicing/accounting/payment-methods',
          dimensions: '/settings/modules/invoicing/accounting/dimensions',
          paymentfiles: '/settings/modules/invoicing/payment-files',
        },
        articles: {
          rent: '/settings/modules/invoicing/articles/rent',
          vacancy: '/settings/modules/invoicing/articles/vacancy',
          invoice: '/settings/modules/invoicing/articles/invoice',
          consumable: '/settings/modules/invoicing/articles/consumable',
          overriddenArticles: '/settings/modules/invoicing/articles/overridden',
          categories: '/settings/modules/invoicing/articles/categories',
        },
        invoicingsettings: {
          contractinvoicing:
            '/settings/modules/invoicing/invoicingsettings/contractinvoicing',
          paymentterms:
            '/settings/modules/invoicing/invoicingsettings/paymentterms',
        },
        pdfconfig: '/settings/modules/invoicing/pdfconfig',
        deliveryinstructions:
          '/settings/modules/invoicing/delivery-instructions',
        vacancies: '/settings/modules/invoicing/vacancies',
        contractinvoicingmessages: '/settings/modules/invoicing/messages',
      },
      communication: {
        notificationtemplates: {
          default: '/settings/modules/communication/notification-templates',
          edit: (event: string) =>
            `/settings/modules/communication/notification-templates/${event}/edit`,
        },
        sendouttemplates: {
          default: '/settings/modules/communication/send-out-templates',
        },
      },
      tenantportal: {
        customercommunicationconfiguration: {
          default:
            '/settings/modules/tenant-portal/customer-communication-configuration',
          detail: (id: FieldValue<string>) =>
            `/settings/modules/tenant-portal/customer-communication-configuration/${id}`,
        },
        automationconfiguration: {
          default: '/settings/modules/tenant-portal/automationconfiguration',
        },
        chat: {
          chatgroupconfiguration:
            '/settings/modules/tenant-portal/chat/chatgroup-configuration',
        },
        tenantinformation: {
          default: '/settings/modules/tenant-portal/tenant-information',
          detail: (tenantInformationCollectionId: FieldValue<string>) =>
            `/settings/modules/tenant-portal/tenant-information/${tenantInformationCollectionId}`,
        },
      },
      market: {
        queues: {
          apartmentQueues: '/settings/modules/market/queues/apartment-queues',
          industrialPremisesQueues:
            '/settings/modules/market/queues/industrial-premises-queues',
          parkingSpotQueues:
            '/settings/modules/market/queues/parkingspot-queues',
          queueRules: '/settings/modules/market/queues/queue-rules',
          presets: '/settings/modules/market/queues/presets',
        },
        configurations: '/settings/modules/market/configurations',
        requirementProfiles: {
          overview: '/settings/modules/market/requirement-profiles',
          apartment: {
            overview: '/settings/modules/market/requirement-profiles/apartment',
          },
          parkingspot: {
            overview:
              '/settings/modules/market/requirement-profiles/parkingspot',
          },
          globals: {
            overview: '/settings/modules/market/requirement-profiles/globals',
          },
        },
        terms: {
          overview: '/settings/modules/market/rentable-terms',
          apartment: {
            overview: '/settings/modules/market/rentable-terms/apartment',
            edit: (id: FieldValue<string>) =>
              `/settings/modules/market/rentable-terms/apartment/${id}`,
          },
          industrialPremises: {
            overview:
              '/settings/modules/market/rentable-terms/industrial-premises',
            edit: (id: FieldValue<string>) =>
              `/settings/modules/market/rentable-terms/industrial-premises/${id}`,
          },
          parkingSpot: {
            overview: '/settings/modules/market/rentable-terms/parking-spot',
            edit: (id: FieldValue<string>) =>
              `/settings/modules/market/rentable-terms/parking-spot/${id}`,
          },
          outdoorSection: {
            overview: '/settings/modules/market/rentable-terms/outdoor-section',
            edit: (id: FieldValue<string>) =>
              `/settings/modules/market/rentable-terms/outdoor-section/${id}`,
          },
        },
      },
    },
  },
  login: {
    authenticate: '/login/authenticate',
    login: '/login',
  },
  f: {
    anonymousLinks: '/f',
  },
  sendOut: {
    edit: (id: string, isTemplate: boolean = false) => {
      const params = queryString.stringify(
        {
          id,
          type: 'edit',
          isTemplate: isTemplate ? 'true' : null,
        },
        { skipNull: true, skipEmptyString: true, arrayFormat: 'comma' }
      );
      return `/sendout?${params}`;
    },
    create: (options?: {
      copyFrom?: string;
      isTemplate?: boolean;
      recipients?: string[];
      recipientsModel?: ModelName;
    }) => {
      const params = queryString.stringify(
        {
          copyFrom: options?.copyFrom,
          type: 'create',
          isTemplate: options?.isTemplate ? true : null,
          recipients: options?.recipients,
          recipientsModel: options?.recipientsModel,
        },
        { skipNull: true, skipEmptyString: true, arrayFormat: 'comma' }
      );
      return `/sendout?${params}`;
    },
  },
  notFound: '/not-found',
} as const;

/**
 * Detail URL for a content type like "contracts.apartmentcontract", or
 * undefined when that model has no detail route. Exists so callers do not each
 * build their own ModelNameUrlMap lookup and drift apart.
 */
export function detailUrlForContentType(
  contentType: string | null | undefined,
  id: string | null | undefined
) {
  const modelName = contentType?.split('.').at(-1);
  if (!modelName || !id) return undefined;
  const urls: Record<string, ((id: string) => string) | undefined> =
    ModelNameUrlMap;
  return urls[modelName]?.(id);
}

export const ModelNameUrlMap = {
  [RevenueIncreaseCollectionConfig.modelName]:
    Urls.detail.revenueIncrease.overview,
  [VerificationGroupConfig.modelName]: Urls.detail.verificationgroup.overview,
  [ExternalSupplierConfig.modelName]: Urls.detail.externalsupplier.overview,
  [ComponentModelConfig.modelName]: Urls.detail.componentmodel.overview,
  [ComponentTypeConfig.modelName]: Urls.detail.componenttype.overview,
  [RoundingSettingConfig.modelName]: Urls.detail.roundingsetting.overview,
  [RoundingOccurrenceConfig.modelName]: Urls.detail.rounds.overview,
  [ParkingSpotListingConfig.modelName]: Urls.detail.parkingSpotListing.overview,
  [IndustrialPremisesListingConfig.modelName]:
    Urls.detail.industrialPremisesListing.overview,
  [ApartmentListingConfig.modelName]: Urls.detail.apartmentListing.overview,
  [InvoicePaymentConfig.modelName]: Urls.detail.invoicepayment.overview,
  [ApartmentConfig.modelName]: Urls.detail.apartment.overview,
  [AddressConfig.modelName]: Urls.detail.address.overview,
  [OrganizationUserConfig.modelName]: Urls.detail.organizationuser.overview,
  [IndustrialPremisesConfig.modelName]: Urls.detail.industrialpremises.overview,
  [OutdoorSectionConfig.modelName]: Urls.detail.outdoorsection.overview,
  [ParkingSpotConfig.modelName]: Urls.detail.parkingspot.overview,
  [CommonAreaConfig.modelName]: Urls.detail.commonarea.overview,
  [RealEstateConfig.modelName]: Urls.detail.realestate.overview,
  [BuildingConfig.modelName]: Urls.detail.building.overview,
  [RegionConfig.modelName]: Urls.detail.region.overview,
  [OutdoorAreaConfig.modelName]: Urls.detail.outdoorarea.overview,
  [ParkingLotConfig.modelName]: Urls.detail.parkinglot.overview,
  [ApartmentContractConfig.modelName]: (id: string) =>
    Urls.detail.contract.overview(ApartmentContractConfig.modelName, id),
  [IndustrialPremisesContractConfig.modelName]: (id: string) =>
    Urls.detail.contract.overview(
      IndustrialPremisesContractConfig.modelName,
      id
    ),
  [OutdoorSectionContractConfig.modelName]: (id: string) =>
    Urls.detail.contract.overview(OutdoorSectionContractConfig.modelName, id),
  [ParkingSpotContractConfig.modelName]: (id: string) =>
    Urls.detail.contract.overview(ParkingSpotContractConfig.modelName, id),
  [OtherContractConfig.modelName]: (id: string) =>
    Urls.detail.contract.overview(OtherContractConfig.modelName, id),
  [BlockContractConfig.modelName]: (id: string) =>
    Urls.detail.contract.overview(BlockContractConfig.modelName, id),
  [CommunityConfig.modelName]: Urls.detail.community.overview,
  [CompanyConfig.modelName]: Urls.detail.company.overview,
  [TenantConfig.modelName]: Urls.detail.tenant.overview,
  [SubTenantConfig.modelName]: Urls.detail.subTenant.overview,
  [InvoiceConfig.modelName]: Urls.detail.invoice.overview,
  [PriceGroupConfig.modelName]: Urls.detail.pricegroup.overview,
  [SensorSpecificationConfig.modelName]:
    Urls.detail.sensorspecification.overview,
  [SensorConfig.modelName]: Urls.detail.sensor.overview,
  [SegmentConfig.modelName]: Urls.detail.segment.overview,
  [ExternalClientConfig.modelName]: Urls.detail.externalClient.overview,
  [BrfApartmentConfig.modelName]: Urls.detail.brfApartment.overview,
  [BrfCompanyConfig.modelName]: Urls.detail.brfCompany.overview,
  [ApartmentVacancyNotationConfig.modelName]: (id: string) =>
    Urls.detail.vacancyContract.overview(
      ApartmentVacancyNotationConfig.modelName,
      id
    ),
  [IndustrialPremisesVacancyNotationConfig.modelName]: (id: string) =>
    Urls.detail.vacancyContract.overview(
      IndustrialPremisesVacancyNotationConfig.modelName,
      id
    ),
  [OutdoorSectionVacancyNotationConfig.modelName]: (id: string) =>
    Urls.detail.vacancyContract.overview(
      OutdoorSectionVacancyNotationConfig.modelName,
      id
    ),
  [ParkingSpotVacancyNotationConfig.modelName]: (id: string) =>
    Urls.detail.vacancyContract.overview(
      ParkingSpotVacancyNotationConfig.modelName,
      id
    ),
  [VacancyInvoiceConfig.modelName]: (id: string) =>
    Urls.detail.vacancyInvoice.overview(id),
  [GeneralErrandConfig.modelName]: (id: string) =>
    Urls.detail.errands.overview(id),
  [InspectionErrandConfig.modelName]: (id: string) =>
    Urls.detail.inspections.overview(id),
  [SendOutConfig.modelName]: (id: string) => Urls.detail.sendOut.overview(id),
} as const satisfies Partial<
  Record<ModelName, (id?: FieldValue<string>) => string>
>;
